export const activityMDM = [
  { id: 0, code: "PPRI", label: "Plaisance privée" },
  { id: 1, code: "PRO", label: "Plaisance professionnelle" },
  { id: 2, code: "FRET", label: "Fret" },
  { id: 3, code: "PAMI", label: "N/A" },
];